import { GoToCheckoutButton } from '#components/molecules/Cart/buttons/GoToCheckoutButton/GoToCheckoutButton.js';
import { WithConsolidatedCheckout } from '#components/molecules/WithConsolidatedCheckout/WithConsolidatedCheckout.js';
import { CloseButton, Container, Group, LoadingOverlay, ScrollArea, Stack, Title } from 'ui';

import { useUserShopCarts } from '../../cart/useUserShopCarts';
import { useCartStorage } from '../../hooks/useCartStorage';
import { NoCartData } from '../molecules/NoCartData';
import { Carts } from './Carts/Carts';

type CartsProps = {
  onClose?: () => void;
};

const CartsArea = ({ onClose }: CartsProps) => {
  const { isLoading } = useUserShopCarts();
  return (
    <ScrollArea.Autosize mah="500px" type="hover">
      <Stack gap="lg">
        <Carts onClickCheckout={onClose} />
        <LoadingOverlay visible={isLoading} mih="400px" />
      </Stack>
    </ScrollArea.Autosize>
  );
};

const CartsPreview = ({ onClose }: CartsProps) => {
  const { cartCount } = useCartStorage();

  return (
    <Container p="lg">
      <Stack>
        <Group justify="space-between">
          <Title order={3}>My Cart</Title>
          <CloseButton onClick={onClose} />
        </Group>
        {cartCount ? (
          <CartsArea onClose={onClose} />
        ) : (
          <Container size="sm">
            <NoCartData />
          </Container>
        )}
        <WithConsolidatedCheckout>
          <GoToCheckoutButton onCheckoutClick={onClose} />
        </WithConsolidatedCheckout>
      </Stack>
    </Container>
  );
};

export { CartsPreview };
